import { ConverterType } from '../domain';
const KNOWN_PROTOCOLS = ['http://', 'https://'];
export const pageUrl = {
    types: ['wix.common.PageUrl'],
    [ConverterType.FROM_JSON]: {
        transform: (val) => {
            if (!val) {
                return;
            }
            if (KNOWN_PROTOCOLS.some((protocol) => val.base?.startsWith(protocol))) {
                return `${val.base}${val.path}`;
            }
            return `http://${val.base}${val.path}`;
        },
    },
    [ConverterType.TO_JSON]: {
        transform: (val) => {
            if (!val) {
                return;
            }
            const { host, pathname } = new URL(val);
            return {
                base: host,
                path: pathname, // (e.g /product-page/a-product)
            };
        },
    },
};
//# sourceMappingURL=page-url.js.map